import { FILTER_TYPES } from 'components/FilterPod';

export const STATUS_BRANCH_OPTIONS = [
  {
    value: true,
    label: 'فعال',
  },

  {
    value: false,
    label: 'غیرفعال',
  },
];

const filters = (getCredit) => [
  {
    title: 'شناسه حساب',
    label: 'شناسه حساب',
    keyName: 'id',
    query: 'id',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'نوع حساب',
    label: 'نوع حساب',
    keyName: 'guildCode',
    query: 'query',
    id: 2,
    value: null,
    filterType: FILTER_TYPES.autocomplete,
    getValueLabel: (v) => v?.label ?? v?.name ?? '',
    filterProps: {
      getList: getCredit,
      useLocalState: true,
    },
  },
  {
    title: 'وضعیت حساب',
    label: 'وضعیت حساب',
    keyName: 'enable',
    query: 'enable',
    id: 1649,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'true',
          label: 'فعال',
        },
        {
          value: 'false',
          label: 'غیرفعال',
        },
      ],
    },
  },
  {
    title: 'نوع تایید',
    label: 'نوع تایید',
    keyName: 'confirmTool',
    query: 'confirmTool',
    id: 16490,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: ['MULTI_CONFIRMATION_VERIFY_TOOL_SMS'],
          label: 'پیامک',
        },
        {
          value: ['MULTI_CONFIRMATION_VERIFY_TOOL_API'],
          label: 'سرویس',
        },
        {
          value: ['MULTI_CONFIRMATION_VERIFY_TOOL_SMS', 'MULTI_CONFIRMATION_VERIFY_TOOL_API'],
          label: 'پیامک - سرویس',
        },
      ],
    },
  },
];

export default filters;
